import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PodcastsView } from '@/models/docs.list.podcasts'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyPodcastsBlock',
  props: {
    view: {},
    term: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(EmptyListingBlock, {
    class: "podcasts-block__empty container",
    title: "Podcasts",
    useDefaultImage: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", null, "No podcasts found for \"" + _toDisplayString(__props.term) + "\"", 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " Try a different search, or email us a list of podcasts you want us to cover! ", -1)),
      _createVNode(_component_router_link, {
        to: { name: 'help' },
        class: "btns btns--font-medium btns--white"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Request podcasts", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})